import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export function useCaptchaChallenge() {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [captchaError, setCaptchaError] = useState("");
  const withCaptcha = async (
    action: (token: string) => Promise<boolean>,
  ): Promise<boolean> => {
    setCaptchaError("");
    try {
      if (!process.env.REACT_APP_CAPTCHA_SITE_KEY || !recaptchaRef.current)
        throw new Error();
      const token = await recaptchaRef.current.executeAsync();
      if (!token) throw new Error();
      return await action(token);
    } catch {
      setCaptchaError(
        "CAPTCHA verification could not complete. Please try again.",
      );
      return false;
    } finally {
      // Tokens are single use. Never reuse one after an account request fails.
      recaptchaRef.current?.reset();
    }
  };
  return { recaptchaRef, captchaError, withCaptcha };
}
